import { SET_CUSTOMER_CERTIFICATE } from "./actions.types";

export const updateCustomerCertificateAction = (customerCertificate: any) => {
  return {
    type: SET_CUSTOMER_CERTIFICATE,
    customerCertificate,
  };
};
